export enum HeartstylesQuadrantNames {
  humility = 'humility',
  love = 'love',
  pride = 'pride',
  fear = 'fear',
}
